var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleTable',{ref:"ToggleTable",attrs:{"headers":_vm.headers,"items":_vm.hunts},scopedSlots:_vm._u([{key:"table-row",fn:function(ref){
var props = ref.props;
return [_c('HuntTableRow',{key:props.index,attrs:{"props":props},on:{"expand":_vm.expandTable}})]}},{key:"creation-form",fn:function(ref){
var props = ref.props;
var close = ref.close;
return [_c('Hunt',{attrs:{"initial-hunt":props.item},on:{"cancel":close,"close":close}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }